<template>
  <div class="header">
    <a-breadcrumb>
      <a-breadcrumb-item v-for="(item, index) in breadcrumbItems" :key="index">
        <router-link v-if="item.to" :to="item.to" :style="index === breadcrumbItems.length - 1 ? { fontWeight: 'bold', color: '#000', fontSize: '18px' } : { fontWeight: 'bold', color: '#a6a6a6', fontSize: '18px' }">
          {{ item.text }}
        </router-link>
        <span v-else :style="{ fontWeight: 'bold', color: '#000', fontSize: '18px' }">
          {{ item.text }}
        </span>
      </a-breadcrumb-item>
    </a-breadcrumb>

    <slot />
  </div>
</template>

<script>
export default {
  name: 'DetailsHeader',
  props: {
    breadcrumbItems: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.header {
  background-color: #fff;
  padding: 32px 56px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 24px;
}

.avatar {
  background-color: #d1fae5;
  color: #047857;
  font-size: 14px;
  font-weight: bold;
}

.seller-info h2 {
  font-size: 24px;
  font-weight: 700;
  color: #333;
  margin: 0 0 4px 0;
}

.seller-info p {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

.ant-tag {
  border-radius: 4px;
  font-weight: 600;
}
</style> 